








































import { Component, Prop, Vue } from 'vue-property-decorator';
import { toThousands } from '../../utils/utils';

@Component
export default class SpecialStatistics extends Vue {
    @Prop({ required: true, default: [] })
    public totals!: any[];

    @Prop({ required: true, default: false })
    public showSubmits!: boolean;

    @Prop({ required: false, default: false })
    public isZQB!: boolean;
    public toThousands = toThousands;

    @Prop({ required: false, default: false })
    public isSXH!: boolean;
    public toThousands = toThousands;
}
